import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../config';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PregledIzdatnicePotrosnogMaterijalaService {
  constructor(private _http: HttpClient) {}

  dohvatiIzdatnicePotrosnogMaterijala(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_izdatnice_potrosnog_materijala', a)
      .pipe(map((res: any) => res));
  }

  dohvatiJednuIzdatnicu(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_jednu_izdatnicu', a)
      .pipe(map((res: any) => res));
  }

  tmpprometstavkePopis(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'tmpprometstavkePopis', a)
      .pipe(map((res: any) => res));
  }

  tmpprometstavkeDodaj(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'tmpprometstavkeDodaj', a)
      .pipe(map((res: any) => res));
  }

  tmpprometstavkeUredi(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'tmpprometstavkeUredi', a)
      .pipe(map((res: any) => res));
  }

  izdatnicaPotrosniMaterijalZavrsi(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'izdatnica_potrosni_materijal_zavrsi', a)
      .pipe(map((res: any) => res));
  }

  izdatnicaPotrosniMaterijalObrisi(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'izdatnica_potrosni_materijal_obrisi', a)
      .pipe(map((res: any) => res));
  }

  tmpprometstavkeObrisi(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'tmpprometstavkeObrisi', a)
      .pipe(map((res: any) => res));
  }

  artiklPopisZaPoslovnicu(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'artiklPopisZaPoslovnicu', a)
      .pipe(map((res: any) => res));
  }

  izdatnicaPotrosniMaterijalStorno(a: any) {
    return this._http.post(AppConfig.ipAddress + 'izdatnica_potrosni_materijal_storno', a)
      .pipe(map((res: any) => res));
  }

  poslovnicaPopis(a: any) {
    return this._http.post(AppConfig.ipAddress + 'poslovnicaPopis', a)
      .pipe(map((res: any) => res));
  }

  izdatnicaPotrosniMaterijalDodaj(a: any) {
    return this._http.post(AppConfig.ipAddress + 'izdatnica_potrosni_materijal_dodaj', a)
      .pipe(map((res: any) => res));
  }

  izdatnicaPotrosniMaterijalUredi(a: any) {
    return this._http.post(AppConfig.ipAddress + 'izdatnica_potrosni_materijal_uredi', a)
      .pipe(map((res: any) => res));
  }

}